import zhLocale from "element-ui/lib/locale/lang/zh-CN";
export const cn = {
  /* A字打头时公共的 */
  A001: "首页",
  A002: "行程预定",
  A003: "国内机票",
  A004: "国际机票",
  A005: "酒店预订",
  A006: "火车票",
  A007: "我的申请",
  A008: "我的审批",
  A009: "我的订单",
  A010: "搜 索",
  A011: "新 建",
  A012: "重 置",
  A013: "操作日志",
  A014: "操作时间",
  A015: "操作人姓名",
  A016: "操作内容",
  A017: "操作备注",
  A018: "暂无操作日志",
  A019: "出行人",
  A020: "查看详情",
  A021: "输入关键字进行过滤",
  A022: "中文名/工号/手机号/邮箱",
  A023: "部 门",
  A024: "请选择部门",
  A025: "员工号",
  A026: "员工类型",
  A027: "姓 名",
  A028: "性 别",
  A029: "用户类型",
  A030: "部门名称",
  A031: "手机号",
  A032: "电子邮箱",
  A033: "已选",
  A034: "人",
  A035: "取 消",
  A036: "确 认",
  A037: "上 传 附 件",
  A038: "最多上传五个附件",
  A039: "附件信息",
  A040: "选择出行人",
  A041: "审批信息",
  A042: "审批节点名称",
  A043: "审批人",
  A044: "审批类型",
  A045: "审批节点状态",
  A046: "备 注",
  A047: "编 辑",
  A048: "删 除",
  A049: "保 存",
  A050: "我的申请",
  A051: "提 交",
  A052: "返 回",
  A053: "已等待",
  A054: "全部",
  A055: "成本中心",
  A056: "时间段",
  A057: "出发城市",
  A058: "到达城市",
  A059: "出发日期",
  A060: "出差类型",
  A061: "请选择出发城市",
  A062: "请选择到达城市",
  A063: "请选择出发日期",
  A064: "周",
  A065: "返程日期",
  A066: "请选择返程日期",
  A067: "筛选条件",
  A068: "因公",
  A069: "高级搜索",
  A070: "查 询",
  A071: "出行人选择",
  // 'A072': '当前公司未开启因公无TR预定',Please select the travel list
  A072: "请选择出差单",
  A073: "请选择差旅人",
  A074: "差旅等级为空，不可查询",
  A075: "出行人差旅政策不一致,请选择适配的差旅人：",
  A076: "出行人与查询时不一致，请重新进行查询",
  A077: "违背差旅政策",
  A078: "不可预订",
  A079: "清空全部",
  A080: "不限",
  A081: "按时间",
  A082: "按价格",
  A083: "违 规",
  A084: "退改签",
  A085: "退票规定",
  A086: "改签规定",
  A087: "预 订",
  A088: "差旅级别名称",
  A089: "继续预订",
  A090: "违规原因选择",
  A091: "根据贵公司的差旅政策规定",
  A092: "违背了以下规则",
  A093: "请选择违规原因",
  A094: "其他原因",
  A095: "请输入违规原因",
  A096: "单价",
  A097: "退改签说明",
  A098: "违规政策",
  A099: "证件姓名",
  A100: "证件类型",
  A101: "证件号码",
  A102: "请维护出行人证件信息",
  A103: "预订人部门",
  A104: "预订人姓名",
  A105: "预订人手机号",
  A106: "预订人",
  A107: "订单确认",
  A108: "服务费",
  A109: "总金额",
  A110: "金额明细",
  A111: "出票单",
  A112: "改签单",
  A113: "退票单",
  A114: "订单状态",
  A115: "审批状态",
  A116: "请选择订单状态",
  A117: "请选择审批状态",
  A118: "查看订单",
  A119: "预订时间",
  A120: "订单信息",
  A121: "票号",
  A122: "退 票",
  A123: "改 签",
  A124: "人数",
  A125: "总价",
  A126: "成人",
  A127: "酒店",
  A128:
    "对于退票，请尽量填写清楚希望退票的相关信息，以便后台服务人员能尽快处理。如果描述不够清晰，您将受到后台服务人员的电话询问，请保持电话通畅。",
  A129:
    "对于改签，请尽量填写清楚希望改签的相关信息，以便后台服务人员能尽快处理。如果描述不够清晰，您将受到后台服务人员的电话询问，请保持电话通畅。",
  A130: "请至少选择一人退票",
  A131: "请至少选择一人改签",
  A132: "请填写退票原因",
  A133: "请填写改签原因",
  A134: "退票手续费说明",
  A135: "退票人",
  A136: "退票人部门",
  A137: "退票人姓名",
  A138: "退票人手机号",
  A139: "因退原票价",
  A140: "退票费",
  A141: "应退金额",
  A142: "申请",
  A143: "查看",
  A144: "审批",
  A145: "订单",
  A146: "出票单详情",
  A147: "身份证",
  A148: "返 回",
  A149: "改签费",
  A150: "改签时间",
  A151: "原单号",
  A152: "成本中心名称",
  A153: "退票车票信息",
  A154:
    "1. 开车前8天（不含）以上退票的，不收取退票费；2. 开车时间前48小时以上,8天以内的按票价5%收取退票费；3. 开车时间24小时以上、不足48小时的按票价10%收取退票费；4. 开车时间不足24小时的按票价20%收取退票费。5.开车前48小时～15天期间内，改签或变更到站至距开车15天以上的其他列车，又在距开车15天前退票的，仍核收5%的退票费。注：以上线上退票只适用于未取出纸质车票且不晚于开车前30分钟的车票** 广深港高铁退票手续费说明：**- 票面开车时间前48小时内 按票面价的50%计算，退票费按元计算，不足一元的部分舍去免收- 票面开车时间前48小时至第14天按票面价的30%计算，退票费按元计算，不足一元的部分舍去免收- 票面开车时间前15天及以上的 按票面价的5%计算，退票费按元计算，不足一元的部分舍去免收。",
  A155: "预订人信息",
  A156: "火车票退票单",
  A157: "退票单详情",
  A158:
    "退票手续费说明: 1. 开车前15天（不含）以上退票的，不收取退票费；2. 开车时间前48小时以上,15天以内的按票价5%收取退票费；3. 开车时间24小时以上、不足48小时的按票价10%收取退票费；4. 开车时间不足24小时的按票价20%收取退票费。5.开车前48小时～15天期间内，改签或变更到站至距开车15天以上的其他列车，又在距开车15天前退票的，仍核收5%的退票费。注：以上线上退票只适用于未取出纸质车票且不晚于开车前30分钟的车票广深港高铁退票手续费说明：- 票面开车时间前48小时内 按票面价的50%计算，退票费按元计算，不足一元的部分舍去免收 - 票面开车时间前48小时至第14天 按票面价的30%计算，退票费按元计算，不足一元的部分舍去免收- 票面开车时间前15天及以上的 按票面价的5%计算，退票费按元计算，不足一元的部分舍去免收。改签手续费说明：办理车票改签或“变更到站”时，对于新车票票价低于原车票的（即高改低），退还差额，对差额部分核收手续费，手续费收取规则执行现行退票费标准，时间以原车票的发车时间进行计算。注：1.退票费最低按2元计收。 2.改签后的车票乘车日期在春运期间的，退票时一律按开车时间前不足24小时标准核收退票费。3.对于停运车次，退票是否收取手续费的问题，一律根据12306发布的公告。4.以上手续费的收取解释权一律归12306所有特殊说明：乘车时间是春运期间，春运期间未经过改签的退票按照正常手续费收取。改签后（含变更到站）日期在春运期间的，退票时铁路局一律收取20%的退票手续费。一切以铁路局最终公布信息为准！广深港高铁改签说明：1.到站为香港西九龙站的车票，办理改签应不晚于票面指定的日期、车次开车前30分钟；发站为香港西九龙站的车票应不晚于60分钟。2.改签后的车票不得退票。",
  A159: "退票时间",
  A160: "退票单号",
  A161: "退票信息",
  A162: "查看退票",
  A163: "实退金额",
  A164: "退票原因",
  A165: "退改签规定",
  A166: "应退原票价",
  A167: "改签人",
  A168: "改签人部门",
  A169: "改签人姓名",
  A170: "改签人手机号",
  A171: "查看改签",
  A172: "改签总金额",
  A173: "热门城市",
  A174: "请选择违背原因",
  A175: "人员有变动，请重新确认管控的差旅等级",
  A176: "起",
  A177: "差旅政策",
  A178: "不管控",
  A179: "地址",
  A180: "注:  地图标志位置仅供参考，具体情况以实际道路标识信息为准",
  A181: "无",
  A182: "订单查询中...",
  A183: "订单详情查询中...",
  A184: "通过中...",
  A185: "驳回中...",
  A186: "转审中...",
  A187: "审批单查询中...",
  A188: "审批详情查询中...",
  A189: "暂无城市数据",
  A190: "对不起，没有找到",
  A191: "违背政策",
  A192: "张",
  A193: "请选择证件类型",
  A194: "有效期",
  A196: "选择月",
  A197: "确认关闭？",
  A198: "机票查询中...",
  A199: "服务热线",
  A200: "退 出",
  A201: "账号登录",
  A202: "用户名/手机号",
  A203: "请输入",
  A204: "企业号",
  A205: "密码",
  A206: "验证码",
  A207: "登 录",
  A208: "登录成功",
  A209: "正在登录...",
  A210: "确定退出？",
  A211: "中文简体",
  A212: "备注",
  A213: "验证码登录",
  A214: "请输入验证码",
  A215: "请输入手机号",
  A216: "发送验证码",
  A217: "微信登录",
  A218: "请输入用户名",
  A219: "请输入密码",
  A220: "机场",
  A221: "国内热门",
  A222: "预订成功",
  A223: "预订失败",
  A224: "加载中...",
  A225: "提前",
  A226: "通告",
  A227: "我的行程",
  A228: "历史行程",
  A229: "行程加载中...",
  A230: "暂无行程信息",
  A231: "北京",
  A232: "上海",
  A233: "上海航空",
  A234: "东方航空",
  A235: "扫码关注：随时移动预订",
  /* 衣恋 */
  A236: "公众号：玉瓷商旅",
  A237: "暂无数据",
  A238: "请使用微信扫描二维码登录",
  /* 衣恋 */
  A239: "玉瓷商旅",
  A240: "公司管理",
  A241: "公众号：衣恋差旅管理",
  A242: "“衣恋差旅”",
  A243: "公众号：壹悠商旅管理",
  A244: "“壹悠商旅”",
  A245: "请填写其他违规原因",
  A246: "机票差价",
  A247: "基建燃油费差价",
  A248: "继续提交",


  /* B字打头是出差申请  其中会包含一些业务模块的单词 */
  B001: "出差申请",
  B002: "出差事由/单号/申请人/出行人/费用成本中心/申请人部门",
  B003: "出差日期",
  B004: "选择出差开始日期",
  B005: "选择出差结束日期",
  B006: "暂无出差申请单",
  B007: "出差事由",
  B008: "出差时间段",
  B009: "申请部门",
  B010: "申请人",
  B011: "申请时间",
  B012: "出差开始日期",
  B013: "出差结束日期",
  B014: "费用归属成本中心",
  B015: "总预算",
  B016: "请选择费用归属成本中心",
  B017: "出差人员",
  B018: "请输入出差事由",
  B019: "出差明细",
  B020: "交通明细",
  B021: "住宿明细",
  B022: "餐饮明细",
  B023: "补贴明细",
  B024: "其他明细",
  B025: "费用科目",
  B026: "出发地",
  B027: "入住城市",
  B028: "到达地",
  B029: "城市",
  B030: "入住日期",
  B031: "开始日期",
  B032: "日期",
  B033: "",
  B034: "离店日期",
  B035: "结束日期",
  B036: "返程日期",
  B037: "天数",
  B038: "预算",
  B039: "总补贴",
  B040: "差旅费-国内机票",
  B041: "差旅费-国际机票",
  B042: "差旅费-火车票",
  B043: "差旅费-住宿",
  B044: "差旅费-餐饮",
  B045: "差旅费-补贴",
  B046: "差旅费-其他",
  B047: "单 程",
  B048: "往 返",
  B049: "类别",
  B050: "每日补贴",
  B051: "查看出差申请",
  B052: "修改出差申请",
  B053: "新建出差申请",
  B054: "请先维护审批信息再进行相关操作！",
  B055: "请填写必要信息！",
  B056: "请选择出差人员！",
  B057: "请维护出差明细！",
  B058: "出差申请明细",
  B059: "是否确定删除此出差申请明细?",
  B060: "出差申请单",
  B061: "请选择出差申请单",
  B062: "出差单号",
  B063: "请输入出差单号",
  B064: "出差申请单提交中...",
  B065: "关联订单",
  B066: "行程信息",

  /* C 打头的是机票 国内 国际都包括 */
  C001: "暂无您查询的机票",
  C002: "航空公司",
  C003: "舱位",
  C004: "机型",
  C005: "起飞机场",
  C006: "到达机场",
  C007: "只看直飞",
  C008: "不看共享",
  C009: "不看违规",
  C010: "舱位等级",
  C011: "航班号",
  C012: "共享",
  C013: "",
  C014: "经停",
  C015: "收起",
  C016: "展开",
  C017: "大于9张",
  C018: "折",
  C019: "全价",
  C020: "已选航班",
  C021: "经停城市",
  C022: "经停时间",
  C023: "折扣",
  C024: "税费",
  C025: "验价失败,请选其他航班",
  C026: "全天内最低价航班",
  C027: "起飞",
  C028: "到达",
  C029: "前后",
  C030: "小时内最低价航班",
  C031: "机票信息",
  C032: "不含税费",
  C033: "票价",
  C034: "基建费",
  C035: "燃油费",
  C036: "重选航班",
  C037: "国内机票预定",
  C937: "国内机票订单保存",
  C038: "是否确认提交国内机票预定？",
  C938: "是否确认保存国内机票订单？",
  C039: "出发/到达机场名称",
  C040: "起飞时段",
  C041: "最早出发日期",
  C042: "最晚出发日期",
  C043: "",
  C044: "暂无符合条件的国内订单",
  C045: "出发机场",
  C046: "到达机场",
  C047: "国内订单",
  C048: "国内航班明细",
  C049: "全天最低价航班信息",
  C050: "起飞时间",
  C051: "小时最低价航班信息",
  C052: "票面价",
  C053: "行程类型",
  C054: "航班信息",
  C055: "应退机建费",
  C056: "应退燃油费",
  C057: "说明：退票费仅供参考，以差旅顾问最终确认的费用为准！",
  C058: "国内机票退票",
  C059: "是否确认提交国内机票退票单？",
  C060: "国内退票",
  C061: "应退票面价",
  C062: "可改签航班信息",
  C063: "改签航班信息",
  C064: "原航班信息",
  C065: "说明：改签费费仅供参考，以差旅顾问最终确认的费用为准！",
  C066: "国内机票改签",
  C067: "是否确认提交国内机票改签单？",
  C068: "国内改签",
  C069: "国际订单",
  C070: "选择去程",
  C071: "选择返程",
  C072: "显示更多舱位",
  C073: "隐藏舱位",
  C074: "儿童价",
  C075: "婴儿价",
  C076: "退改费用说明",
  C077: "停留时长",
  C078: "中转",
  C079: "飞行时长",
  C080: "",
  C081: "去",
  C082: "返",
  C083: "行李额度",
  C084: "当地时间",
  C085: "选为去程",
  C086: "选为返程",
  C087: "退改签规则查询中，请稍后再试...",
  C088: "行李信息查询中，请稍后再试...",
  C089: "验仓验价中...",
  C090: "请选择航空公司",
  C091: "请选择舱位",
  C092: "国际机票订单提交中...",
  C093: "国内机票订单提交中...",
  C094: "国内机票退票订单提交中...",
  C095: "国内机票改签订单提交中...",
  C096: "国际航班明细",
  C097: "国际机票预订",
  C098: "联系人姓名",
  C099: "联系人邮箱",
  C100: "区 号",
  C101: "行程",
  C102: "确 定",
  C103: "当前票价",
  C104: "请选择归属成本中心",
  C105: "飞行时长超过",
  C106: "小时",
  C107: "公里",
  C108: "是否确认提交国际机票预订？",
  C109: "期望舱位",
  C110: "申请人成本中心",
  C111: "基本信息",
  C112: "取消申请",
  C113: "方案申请",
  C114: "取消申请成功",
  C115: "取消申请失败",
  C116: "新建方案申请",
  C117: "请选择申请人成本中心",
  C118: "请选择申请人",
  C119: "请输入备注",
  C120: "编辑行程",
  C121: "出发时间",
  C122: "增加行程",
  C123: "请添加航段",
  C124:
    "国际航班复杂行程，请提交出行方案申请，专业的差旅顾问将为您定制国际行程方案",
  C125: "新增方案申请",
  C126: "方案",
  C127: "供应商",
  C128: "报价时长",
  C129: "确认方案 ",
  C130: "是 ",
  C131: "否 ",
  C132: "此操作将取消这个方案申请, 是否继续? ",
  C133: "国际方案申请 ",
  C134: "差旅顾问已经收到您的需求，正在努力为您定制出行计划，请耐心等待...  ",
  C135: "请输入总预算 ",
  C136: "驳回报价 ",
  C137: "请输入航班号 ",
  C138: "修改申请成功 ",
  C139: "提交申请成功 ",
  C140: "保存申请成功 ",
  C141: "国际出行计划 ",
  C142: "是否确认删除该计划 ",
  C143: "请输入航班时间 ",
  C144: "是否驳回该报价方案 ",
  C145: "国内机票取消",
  C146: "是否确认取消该订单？",
  C147: "国内机票继续提交",
  C148: "是否继续提交该订单？",

  /* D 打头的是火车票 */
  D001: "火车票",
  D002: "暂无您查询的火车票",
  D003: "车次",
  D004: "出发",
  D005: "到达",
  D006: "价格",
  D007: "在线选座",
  D008: "收起经停",
  D009: "查看经停",
  D010: "已选改签车次信息",
  D011: "余票",
  D012: "充足",
  D013: "",
  D014: "分钟",
  D015: "筛选",
  D016: "清空",
  D017: "车型",
  D019: "动车",
  D018: "已选车次",
  D020: "直达",
  D021: "特快",
  D022: "高铁",
  D023: "其他",
  D025: "发车时间",
  D026: "",
  D027: "出发车站",
  D028: "到达车站",
  D029: "座位",
  D030:
    "温馨提示：由于火车票座位位置不同，票价稍有差别，最终以实际出票价格为准",
  D031: "",
  D032: "联系人",
  D033: "提示",
  D034: "是否接受无座?",
  D035: "拒绝",
  D036: "接受",
  D037: "请输入联系人姓名",
  D038: "请输入联系人手机号",
  D039: "车票信息",
  D040: "在线选座",
  D041: "选座后如系统票额不足，系统将随机为您申请座位",
  D042: "窗",
  D043: "过道",
  D044: "原车次信息",
  D045: "火车票预定",
  D046: "是否确认提交火车票预定？",
  D047: "出发车站",
  D048: "到达车站",
  D049: "暂无符合条件的火车票订单",
  D050: "出发/到达车站",
  D051: "出发日期",
  D052: "到达日期",
  D053: "该车次不可改签",
  D054: "是否确认提交火车票改签单？",
  D055: "改签车次信息",
  D056: "火车票明细",
  D057: "火车票查询",
  D058: "火车票改签",
  D059: "改签单详情",
  D060: "火车票退票",
  D061: "是否确认提交火车票退票单？",
  D062: "火车票审批",
  D063: "火车票退票订单提交中...",
  D064: "火车票改签订单提交中...",
  D065: "火车票订单提交中...",

  /* E打头的是酒店 */
  E001: "目的地",
  E002: "请选择目的地",
  E003: "请选择入店时间",
  E004: "请选择离店时间",
  E005: "关键词",
  E006: "请选择关键词",
  E007: "请先确认目的地！",
  E008: "请选择目的地！",
  E009: "请选择入住日期！",
  E010: "请选择离店日期！",
  E011: "位置区域",
  E012: "房 价",
  E013: "元及以下",
  E014: "元",
  E015: "元及以上",
  E016: "最大金额不可小于最小金额！",
  E017: "星 级",
  E018: "品 牌",
  E019: "酒店设施",
  E020: "暂无您查询的酒店",
  E021: "请完整输入金额范围！",
  E022: "酒店星级",
  E023: "一级城市标准",
  E024: "二级城市标准",
  E025: "三级城市标准",
  E026: "浏览历史",
  E027: "酒店详情",
  E028: "酒店位置",
  E029: "房型列表",
  E030: "酒店信息",
  E031: "酒店电话",
  E032: "酒店政策",
  E033: "酒店介绍",
  E034: "暂无图片",
  E035: "早餐",
  E036: "份",
  E037: "特价房",
  E038: "不可取消",
  E039: "限时取消",
  E040: "需在",
  E041: "日",
  E042: "时之前通知",
  E043: "需在到店日期的24点之前",
  E044: "小时通知",
  E045: "到店付",
  E046: "已选房间",
  E047: "无早",
  E048: "入住时间",
  E049: "共",
  E050: "晚",
  E051: "房间数量",
  E052: "最晚到店时间",
  E053: "月",
  E054: "温馨提示：通常酒店14点办理入住，早到可能需要等待",
  E055: "酒店订单",
  E056: "确认单",
  E057: "退房单",
  E058: "入住人",
  E059: "预定时间",
  E060: "酒店明细",
  E061: "房型",
  E062: "间",
  E063: "无数据",
  E064: "至",
  E065: "单价(均价)",
  E066: "支付信息",
  E067: "取消规则",
  E068: "退 房",
  E069: "房间单价",
  E070: "入住天数",
  E071: "天",
  E072: "注: 总价 = (房间单价 + 服务费) * 入住天数 * 房间数",
  E073: "房间数",
  E074: "酒店预定",
  E075: "是否确认提交酒店预定？",
  E076: "酒店退房",
  E077: "是否确认提交酒店退房？",
  E078: "退房时间",
  E079: "退房规定",
  E080: "退房原因",
  E081: "均价",
  E082: "请填写退房原因",
  E083: "应退原房价",
  E084: "确认单详情",
  E085: "退房单详情",
  E086: "入住离店",
  E087: "酒店名称",
  E088: "暂无符合条件的酒店订单",
  E089: "酒店订单提交中...",
  E090: "酒店退房订单提交中...",
  E091: "是否确认酒店退房？",
  E092: "最晚取消时间为",
  E093: "免费取消时间为",
  E094: "非免费取消时间罚金为",
  E095: "担保金额:",
  E096: "卡号",
  E097: "持卡人",
  E098: "请选择信用卡有效期",
  E099: "该信用卡不可用!",
  E100: "请输入cvv",
  E101: "请输入必填信息",
  E102: "请选择持卡人",
  E103: "一级城市",
  E104: "二级城市",
  E105: "三级城市",
  E106: "商圈",
  E107: "机场/车站",
  E108: "地铁站",
  E109: "品牌",
  E110: "餐食",

  /* F打头的是我的审批 */
  F001: "出差审批",
  F002: "我的审批",
  F003: "审批详情",
  F004: "请输入审批备注",
  F005: "通 过",
  F006: "驳 回",
  F007: "转 审",
  F008: "审批操作",
  F009: "选择转审人",
  F010: "是否确认通过此单据",
  F011: "是否确认驳回此单据",
  F012: "是否确认将此单据转审给",
  F013: "国内机票审批",
  F014: "国际机票审批",
  F015: "酒店审批",

  /* G大头的是个人中心 */
  G001: "基本资料",
  G002: "证件信息",
  G003: "我的秘书",
  G004: "账号安全",
  G005: "家属资料",
  G006: "外部客户",
  G007: "出生日期",
  G008: "登录账号",
  G009: "差旅等级",
  G010: "角 色",
  G011: "编辑资料",
  G012: "用户名",
  G013: "请选择出生日期",
  G014: "保 存",
  G015: "操作成功",
  G016: "操作失败",
  G017: "个人信息保存中...",
  G018: "添加证件",
  G019: "国家名称",
  G020: "操 作",
  G021: "删除后将不能恢复，请谨慎操作",
  G022: "添加证件信息",
  G023: "姓",
  G024: "名",
  G025: "姓（拼音）",
  G026: "名（拼音）",
  G027: "请选择日期",
  G028: "请选择国家名称",
  G029: "编辑证件信息",
  G030: "证件信息保存中...",
  G031: "联系电话(座机)",
  G032: "添加秘书",
  G033: "修改密码",
  G034: "原密码",
  G035: "新密码",
  G036: "确认密码",
  G037: "请输入原密码",
  G038: "请输入新密码",
  G039: "请再次输入密码",
  G040: "两次输入密码不一致!",
  G041: "添加家属",
  G042: "用户中文名",
  G043: "生 日",
  G044: "国 籍",
  G045: "添加家属信息",
  G046: "编辑家属信息",
  G047: "修改密码中...",
  G048: "家属资料保存...",
  G049: "外部客户信息保存...",
  G050: "添加外部客户",
  G051: "编辑外部客户",
  G052: "添加客户",
  G053: "代审设置",
  G054: "我的代理审批人",
  G055: "选择代理审批人",
  G056: "清空代理审批人",
  G057: "生效日期范围",
  G058: "确定清空代理审批人",
  G059: "日期范围",
  // 退票新增字段
  R200: "退票类型",
  R201: "退票原因",
  R202: "情况说明",
  R203: "自愿退票",
  R204: "非自愿退票",
  R205: "因航班变动/取消等原因",
  R206: "健康原因无法乘机",
  R207: "特殊原因无法乘机",
  R208: "其他情况",
  R209: "请选择退票原因",
  R210: "请填写情况说明",
  // 退票详情页展示
  R211: "退票类型",
  R212: "退票原因",
  R213: "情况说明",

  "00000": "请求错误，操作失败！",
  ...zhLocale
};

export default cn;



// WEBPACK FOOTER //
// ./src/i18n/langs/cn.js